import { Component } from "@kluntje/core";

/**
 * Custom Element for the breadcrumb component which provides methods to add or remove breadcrumb items
 */
class FRABreadcrumb extends Component {
  // returns the CURRENT last breadcrumb list item
  get lastBreadcrumb() {
    return (this.ui.breadcrumbList as HTMLOListElement).lastElementChild as HTMLElement;
  }

  constructor() {
    super({
      ui: {
        breadcrumbList: ".fra-m-breadcrumb__list :-one",
      },
    });
  }

  /**
   * add a breadcrumb to the end of the current breadcrumbs
   * @param {string} title - title of the breadcrumb step
   */
  addBreadcrumb(title: string) {
    const lastBreadcrumb = this.lastBreadcrumb;
    // link to the current page (without the hash)
    lastBreadcrumb.innerHTML = `<a href="" class="fra-m-breadcrumb__anchor">${lastBreadcrumb.textContent}</a>`;
    lastBreadcrumb.insertAdjacentHTML(
      "afterend",
      `<li class="fra-m-breadcrumb__list-item"><span aria-current="page">${title}</span></li>`,
    );
  }

  /**
   * remove the last breadcrumb item
   */
  removeLastBreadcrumb() {
    this.lastBreadcrumb.remove();
    // change the new last breadcrumb from anchor to a span
    this.lastBreadcrumb.innerHTML = `<span aria-current="page">${this.lastBreadcrumb.textContent}</span>`;
  }
}

customElements.define("fra-m-breadcrumb", FRABreadcrumb);

export default FRABreadcrumb;

